export default __webpack_public_path__ + "static/media/motupatlo.493bf900.jpg";